<template>
    <div class="report-container">
        <power-b-i-report-embed
            :embed-config="config"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { PowerBIReportEmbed } from 'powerbi-client-vue-js';
import { models } from 'powerbi-client';
import { IPowerBiReportToken } from '@/interfaces/deltaGpt/IPowerBiReportToken.ts';

const props = defineProps<{ reportToken: IPowerBiReportToken }>();

const config = computed(() => ({
    type: 'report',
    id: props.reportToken.reportId,
    embedUrl: props.reportToken.embedUrl,
    accessToken: props.reportToken.embedToken,
    tokenType: models.TokenType.Embed,
    settings: {
        panes: {
            filters: {
                expanded: false,
                visible: false,
            },
        },
    },
}));

</script>

<style scoped lang="scss">
.report-container {
    width: 100%;
    height: 100%;
}

:deep(#reportContainer) {
    width: 100%;
    height: 100%;
}
</style>
